import { ArrowRight, ShoppingCart, Trash2, X } from 'lucide-react';
import KitItemThumbnail from './KitItemThumbnail';

const KitMiniCartModal = ({
  isOpen,
  items,
  onClose,
  onRemoveItem,
  onGoToReview,
  kitTypeLabels,
  getImageUrl
}) => {
  if (!isOpen) {
    return null;
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 px-4">
      <div className="bg-white w-full max-w-xl rounded-3xl shadow-2xl overflow-hidden">
        <div className="flex items-center justify-between border-b border-gray-100 px-6 py-4">
          <div>
            <p className="text-xs uppercase tracking-wide text-gray-500">Your Kit</p>
            <h3 className="text-2xl font-bold text-gray-800">Selected Items ({items.length})</h3>
          </div>
          <button
            onClick={onClose}
            className="p-2 rounded-full bg-gray-100 hover:bg-gray-200 transition-colors"
            aria-label="Close kit"
          >
            <X size={22} className="text-gray-600" />
          </button>
        </div>

        <div className="max-h-80 overflow-y-auto divide-y divide-gray-100">
          {items.length === 0 ? (
            <div className="px-6 py-10 text-center text-gray-500 flex flex-col items-center gap-3">
              <ShoppingCart size={40} className="text-orange-400" />
              <p className="text-lg font-semibold text-gray-700">Your kit is empty</p>
              <p className="text-sm">Browse films, containers, or sealing machines to add items.</p>
            </div>
          ) : (
            items.map((item) => (
              <div key={`${item.type}-${item.id}`} className="px-6 py-4 flex items-center gap-4">
                <KitItemThumbnail item={item} size="sm" getImageUrl={getImageUrl} />
                <div className="flex-1 text-left">
                  <p className="text-lg font-semibold text-gray-800">{item.title}</p>
                  <p className="text-sm text-gray-500">
                    {(kitTypeLabels[item.type] || 'Item')}
                    {item.details ? ` • ${item.details}` : ''}
                  </p>
                </div>
                <button
                  onClick={() => onRemoveItem(item.type, item.id)}
                  className="flex items-center gap-2 rounded-full border border-gray-200 px-3 py-1 text-sm text-gray-600 hover:bg-gray-100"
                >
                  <Trash2 size={16} />
                  Remove
                </button>
              </div>
            ))
          )}
        </div>

        <div className="bg-gray-50 px-6 py-4 flex flex-col gap-3">
          <button
            onClick={onGoToReview}
            disabled={items.length === 0}
            className={`w-full flex items-center justify-center gap-2 rounded-xl py-3 text-lg font-semibold text-white transition-all ${
              items.length === 0 ? 'bg-gray-300 cursor-not-allowed' : 'shadow-lg hover:scale-[1.02]'
            }`}
            style={
              items.length === 0
                ? {}
                : {
                    background:
                      'linear-gradient(270deg,#ffa400,#f78900 15.67%,#f07100 33.69%,#eb6000 52.89%,#e85600 73.87%,#e75300)'
                  }
            }
          >
            Review Kit
            <ArrowRight size={20} />
          </button>
          <button
            onClick={onClose}
            className="w-full rounded-xl border border-gray-200 bg-white py-3 text-lg font-semibold text-gray-700 hover:bg-gray-100 transition-colors"
          >
            Keep Browsing
          </button>
        </div>
      </div>
    </div>
  );
};

export default KitMiniCartModal;
